<!-- @bad TODO: Keyboard navigation-->
<ng-container *ngIf="texts$ | async as texts">
    <tui-hosted-dropdown
        *tuiLet="listState$ | async as listState"
        #list
        [content]="listDropdown"
    >
        <button
            tuiIconButton
            type="button"
            size="s"
            icon="tuiIconListLarge"
            appearance="icon"
            tuiHintDirection="top-left"
            automation-id="toolbar__ordering-list-button"
            tuiHintDescribe
            [tuiHint]="texts.list"
            [pseudoActive]="list?.open || listState?.unordered || listState?.ordered || false"
            [focusable]="list.open"
        ></button>
        <ng-template #listDropdown>
            <div class="t-dropdown">
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconListLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.unorderedList"
                    [pseudoActive]="!!listState?.unordered"
                    (click)="editor.toggleUnorderedList()"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconOLLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.orderedList"
                    [pseudoActive]="!!listState?.ordered"
                    (click)="editor.toggleOrderedList()"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconIndentLarge"
                    appearance="icon"
                    class="t-option t-option_margin"
                    [tuiHint]="texts.indent"
                    [disabled]="(!listState?.ordered && !listState?.unordered) || false"
                    (click)="sinkListItem()"
                ></button>
                <button
                    tuiIconButton
                    type="button"
                    size="s"
                    icon="tuiIconOutdentLarge"
                    appearance="icon"
                    class="t-option"
                    [tuiHint]="texts.outdent"
                    [disabled]="(!listState?.ordered && !listState?.unordered) || false"
                    (click)="liftListItem()"
                ></button>
            </div>
        </ng-template>
    </tui-hosted-dropdown>
</ng-container>
